var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.927499 3.42034L4.505 7.48875C4.79 7.81278 5.21 8 5.6525 8L22.3325 8C22.775 8 23.195 7.81278 23.48 7.48875L27.0575 3.42034C27.3425 3.14672 27.5 2.78668 27.5 2.40504L27.5 0L0.5 -2.36041e-06L0.5 2.39784C0.5 2.77948 0.657503 3.14671 0.942503 3.41314L0.927499 3.42034ZM6.91667 10L21.0833 10C21.8657 10 22.5 10.597 22.5 11.3333L22.5 12.6667C22.5 13.403 21.8657 14 21.0833 14L6.91667 14C6.13426 14 5.5 13.403 5.5 12.6667L5.5 11.3333C5.5 10.597 6.13427 10 6.91667 10ZM7 16L21 16L21 22.6316C21 26.6989 17.864 30 14 30C10.136 30 7 26.6989 7 22.6316L7 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenLarge);
export default __webpack_public_path__ + "static/media/pen-large.3569659f50608e64fd68b42d3cdd4a46.svg";
export { ForwardRef as ReactComponent };